import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';

const IssuesSection = () => {
  const issues = [
    { name: 'Complex Trauma and Grief', path: '/trauma' },
    { name: 'Relationship Concerns', path: '/relationship-concerns' },
    { name: 'Abuse', path: '/abuse' },
    { name: 'Gender-based Violence', path: '/gender-based-violence' },
    { name: 'Gender and Sexual Identity Concerns 🌈', path: '/gender-sexual-identity' }
  ];

  return (
    <section className="py-16 md:py-24 px-4 bg-gradient-to-br from-teal-50 to-orange-50">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-teal-800 mb-4">
            Areas We Address
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Our therapeutic approach encompasses various emotional and psychological challenges,
            providing specialized support for each unique journey.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {issues.map((issue, index) => (
            <motion.div
              key={issue.path}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <a
                href={issue.path}
                className="group relative block bg-white overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-teal-800/10 to-orange-400/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                <div className="relative p-8">
                  <div className="mb-4 w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center group-hover:bg-teal-200 transition-colors duration-300">
                    <ChevronRight className="w-6 h-6 text-teal-700 transform group-hover:translate-x-1 transition-transform duration-300" />
                  </div>
                  
                  <h3 className="text-xl font-semibold text-teal-900 mb-2 group-hover:text-teal-700 transition-colors duration-300">
                    {issue.name}
                  </h3>
                  
                  <div className="w-12 h-1 bg-orange-300 rounded group-hover:w-24 transition-all duration-300" />
                </div>
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IssuesSection;